// const placeholderImage = "https://cdn.scoutfeedback.com/gdot-workshop/eic/executive-summary/pix-vertical-placeholder.jpg"

export default {
    svgData: [
      {
        id: "slide1display1",
        name: "Display 1",
        assets: ["https://cdn.scoutfeedback.com/gdot-workshop/eic/executive-summary/0013915+Executive+Summary+Public+Hearing+Handout.jpg"],
        label: "slide1display1"
      },
      {
        id: "slide1display2",
        name: "Display 2",
        url: "https://arcg.is/1zbyKu",
        label: "slide1display2"
      },
      {
        id: "slide1display3",
        name: "Display 3",
        pdf: "https://cdn.scoutfeedback.com/gdot-workshop/eic/executive-summary/EIB_Executive-Summary.pdf",
        label: "slide1display3"
      },
      {
        id: "slide1display4",
        name: "Display 4",
        pdf: "https://cdn.scoutfeedback.com/gdot-workshop/eic/executive-summary/EPC_Executive-Summary.pdf",
        label: "slide1display4"
      },
      {
        id: "slide1display5",
        name: "Display 5",
        pdf: "https://cdn.scoutfeedback.com/gdot-workshop/eic/executive-summary/PMP_Executive-Summary.pdf",
        label: "slide1display5"
      },
      {
        id: "slide1avatar1"
      }
    ],
    slideTitle: "Executive Summary",
    helpText: `
      <p class="text-justify help">
      The I-285/I-20 East Interchange project is a Public-Private Partnership (P3), 
      Design-Build-Finance (DBF) project. In November 2020, a Finding of No Significant Impact (FONSI) 
      was issued for the I-285/I-20 East Interchange project. The FONSI signals the end 
      of the environmental phase of project development and allows Georgia DOT to proceed with the project. 
      </p>

      <p class="text-justify help">
      Georgia DOT is in the process of selecting a developer to complete the 
      final design and construction. The virtual meeting room has been updated to allow public comments 
      on the Proposers’ executive summaries submitted for the project. An executive summary provides information 
      on a Proposers ability to satisfy the financial and technical requirements of the project.
      </p>

      <p class="text-justify help">
      <strong>
      Review the informational handout and each Proposers’ executive summary, and following your review, submit online comment(s).
      </strong>
      </p>

      <p class="text-justify help">
      Your feedback is important to us! Click the tablet on the table to submit an official comment about the executive summary. 
      <strong>Comments should be submitted by Tuesday, March 8, 2022.</strong>
      </p>

      <p class="text-justify help">
      Click the following button <i class="mdi mdi-account-question" style="font-size:2em;"></i> to learn about the specific station 
      or the <i class="mdi mdi-information-outline" style="font-size:2em;"></i> to see this message again after you close it out. 
      Feel free to navigate back to other stations in the virtual meeting space for additional project information.
      To return to the project website, select the <i class="mdi mdi-exit-to-app" style="font-size:2em;"></i> icon.   
      </p>
    `,
    aboutText: `
      <p class="text-justify help">
      Public-Private Partnerships (P3) are partnerships formed between public entities like Georgia DOT 
      and private engineering/construction companies to complement Georgia DOT’s other traditional 
      and innovative delivery methods. Such a partnership allows the state to better allocate the limited resources 
      available for transportation projects by leveraging private sector innovation and capital.
      </p>

      <p class="text-justify help">
      These partnerships accelerate project delivery, provide access to additional capital, 
      enable a longer-term view of asset management, and can reduce public cost and debt requirements. 
      Using these partnerships, Georgia DOT can offer enhanced and expanded mobility options for the traveling public and freight transportation.
      </p>

      <p class="text-justify help">
      There are state and federal regulations that Georgia DOT must follow when a project is pursued as a P3. 
      Georgia DOT must provide an opportunity for public comment on responsive proposers submitted executive summaries. 
      The executive summary is an overview of the proposer’s approach to the project including its ability 
      to satisfy the financial and technical requirements of the project. The executive summary is required to be posted 
      for public comment for 30 days in accordance with current law. 
      </p>
       `
  };
  